import { render } from "./TwoFactorVerificationModal.vue?vue&type=template&id=fdb53c24&scoped=true"
import script from "./TwoFactorVerificationModal.vue?vue&type=script&lang=js"
export * from "./TwoFactorVerificationModal.vue?vue&type=script&lang=js"

import "./TwoFactorVerificationModal.vue?vue&type=style&index=0&id=fdb53c24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb53c24"]])

export default __exports__